import React from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './VenueLine.css';

interface VenueLineProps {
    name?: string;
}

function VenueLine({name}: VenueLineProps): React.ReactElement | null {
    const {t} = useTranslation('eTicket');

    if(!name) {
        return null;
    }

    return (
        <css.venue>{t('venueLabel')} <css.name>{name}</css.name></css.venue>
    );
}

export default VenueLine;
